import { Card } from "@heroui/react";
import { Link } from "react-router-dom";
import type { Campaign } from "../model/types";
import { CampaignCardFooter } from "./CampaignCardFooter";
import { CampaignCardHeader } from "./CampaignCardHeader";
import { CampaignCardStats } from "./CampaignCardStats";

export interface CampaignCardProps {
  campaign: Campaign;
  className?: string;
}

export const CampaignCard = ({
  campaign,
  className = "",
}: CampaignCardProps) => {
  const problems = campaign.problems || [];
  const hasProblems = problems.length > 0;

  const baseClassName = hasProblems ? "border-2 border-rose-500/80" : "";

  return (
    <Link to={`/campaign/${campaign.campaign_id || campaign.id}`}>
      <Card
        className={`hover:bg-neutral-100 transition-colors ${baseClassName} ${className}`.trim()}
      >
        <CampaignCardHeader campaign={campaign} hasProblems={hasProblems} />
        <CampaignCardStats campaign={campaign} />
        <CampaignCardFooter campaign={campaign} />
      </Card>
    </Link>
  );
};
